import { render, staticRenderFns } from "./holdPwd.vue?vue&type=template&id=25721fe6&scoped=true&"
import script from "./holdPwd.vue?vue&type=script&lang=js&"
export * from "./holdPwd.vue?vue&type=script&lang=js&"
import style0 from "./holdPwd.vue?vue&type=style&index=0&id=25721fe6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25721fe6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/vercel/workpath0/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('25721fe6')) {
      api.createRecord('25721fe6', component.options)
    } else {
      api.reload('25721fe6', component.options)
    }
    module.hot.accept("./holdPwd.vue?vue&type=template&id=25721fe6&scoped=true&", function () {
      api.rerender('25721fe6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "srcPC/components/password/holdPwd.vue"
export default component.exports